// extracted by mini-css-extract-plugin
export var container = "EditTotal-module--container--URuUb";
export var content = "EditTotal-module--content--RQ+eT";
export var footer = "EditTotal-module--footer--FP628";
export var input = "EditTotal-module--input--lJfc6";
export var title = "EditTotal-module--title--p3V-c";